import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Sidebar from "arui-feather/sidebar";
import TripsAPI from "../../api/trips-api";
import { Button } from "../ui-kit/styled-templates";
import TripForm from "./TripForm";

import delete_x from "../../assets/images/x.svg";
import TripsListTool from "./tools/TripsListTool";
import toast from "react-hot-toast";


export default function TripsPanel(props) {
    const {
        mode = "edit",
        type,
        hasYandex = false,
        isInternational = false
    } = props;

    const [trips, setTrips] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addModalVisible, setAddModalVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        TripsAPI.getAllTrips().then(arr => {
            setTrips(arr);
            setLoading(false);
        });
    }, []);

    let fTrips = trips
        .filter(x => (x.type == type))
        .sort((a, b) => (b.createdTimestamp || 0) - (a.createdTimestamp || 0));

    if (trips.length == 0 && loading == true) {
        return (
            <div>
                ...
            </div>
        );
    }

    let selectedItem = (selectedId == undefined) ? undefined : trips.filter(x => (x.id == selectedId))[0];

    return (
        <Wrapper>


            {mode != "edit" ? null :
                <TopPlaceholder>
                    <Button onClick={() => {
                        setAddModalVisible(true);
                    }}>
                        Добавить
                    </Button>
                </TopPlaceholder>
            }

            <TripsListTool
                isInternational={isInternational}
                trips={fTrips}
                hasYandex={hasYandex}
                onItemClick={x => {
                    if (x.yandexUrl != undefined && x.yandexUrl != "" && mode != "edit") {
                        window.open(x.yandexUrl, "_blank");
                        return;
                    }
                    if (mode == "edit") {
                        setSelectedId(x?.id);
                    }
                }}
            />


            <Sidebar visible={(selectedItem != undefined)} width={Math.min(1020, window.innerWidth)}
                     onCloserClick={() => {
                         setSelectedId(undefined);
                     }}>

                {selectedItem == undefined ? null :
                    <div>

                        {mode != "view" ?
                            <TripForm {...selectedItem}
                                      hasYandex={hasYandex}
                                      loading={loading}
                                      onSave={async d => {
                                          setLoading(true);
                                          await TripsAPI.updateTrip({ ...d, id: selectedItem?.id });
                                          let arr = await TripsAPI.getAllTrips();
                                          setTrips(arr);
                                          setLoading(false);
                                          setSelectedId(undefined);
                                      }}
                                      onDelete={async () => {
                                          setLoading(true);
                                          await TripsAPI.deleteTrip(selectedItem?.id);
                                          let arr = await TripsAPI.getAllTrips();
                                          setTrips(arr);
                                          setLoading(false);
                                          setSelectedId(undefined);
                                          toast.success("Удалено");
                                      }}

                            />

                            :
                            <div>
                                <h2>
                                    {selectedItem?.name}
                                </h2>
                                <p>
                                    {selectedItem?.description}
                                </p>
                            </div>
                        }

                    </div>
                }

            </Sidebar>

            <Sidebar visible={addModalVisible} onCloserClick={() => {
                setAddModalVisible(false);
            }}>

                {addModalVisible == false ? null :
                    <div>

                        <TripForm
                            loading={loading}
                            hasYandex={hasYandex}
                            onSave={async d => {
                                setLoading(true);
                                await TripsAPI.createTrip({ ...d, type: type });
                                let arr = await TripsAPI.getAllTrips();
                                setTrips(arr);
                                setLoading(false);
                                setAddModalVisible(false);
                            }} />

                    </div>
                }

            </Sidebar>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const TopPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const ItemLeft = styled.div`
  flex: 1;
`;

const ItemRight = styled.div`
  margin-left: 10px;
`;

const TripItem = styled.div`
  padding: 10px;
  border-radius: 4px;
  background: white;
  border: 1px solid whitesmoke;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    opacity: 0.7;
  }
`;

const DescriptionPlaceholder = styled.div`
  font-size: 14px;
  opacity: 0.7;
`;

const TripName = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
`;